import React from 'react';
import { useMeta } from '@/hooks/useMeta';
import { getMetaConfig } from '@/config/metaConfig';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://www.proptpilot.com';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  canonical?: string;
  noIndex?: boolean;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  ogImage,
  canonical,
  noIndex = false,
}) => {
  const location = useLocation();

  // Get default meta config for current route
  const defaultConfig = getMetaConfig(location.pathname);

  // Determine canonical URL: prefer prop, then defaultConfig.canonical, then derive from pathname
  const resolvedCanonical = canonical
    || defaultConfig.canonical
    || `${SITE_URL}${location.pathname === '/' ? '/' : location.pathname.replace(/\/$/, '')}`;

  const metaConfig = {
    title: title || defaultConfig.title,
    description: description || defaultConfig.description,
    keywords: keywords || defaultConfig.keywords,
    ogImage: ogImage || defaultConfig.ogImage,
    ogTitle: title || defaultConfig.title,
    ogDescription: description || defaultConfig.description,
    canonical: resolvedCanonical,
    robots: noIndex ? 'noindex, nofollow' : 'index, follow',
  };

  useMeta(metaConfig);

  return null; // This component doesn't render anything
};

export default SEO;
